module.exports = __webpack_public_path__ + "static/media/workoutArms.7e8b396f.png";